import {
  Directive,
  ElementRef,
  HostListener
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Directive({
  selector: '[awairScrollPrevent]'
})
export class ScrollPreventDirective {

  isExport: boolean = false;
  constructor(
    private router: Router,
    private el: ElementRef) {
    this.router.events.subscribe((events) => {
      if (events instanceof NavigationEnd) {
        if (this.router.url.includes('export')) {
          this.isExport = true;
        } else {
          this.isExport = false;
        }
      }
    });
  }

  @HostListener('mousewheel', ['$event']) onScroll(event: MouseWheelEvent) {
    const scrollHeight = this.el.nativeElement.scrollHeight;
    const scrollTop = this.el.nativeElement.scrollTop;
    const height = this.el.nativeElement.offsetHeight;
    if (!this.isExport && ((scrollTop === (scrollHeight - height) && event.wheelDelta < 0) || (scrollTop === 0 && event.wheelDelta > 0))) {
      event.preventDefault();
    }
  }
}
